import { gql, useLazyQuery } from "@apollo/client";
import { useCallback } from "react";

const GET_DESIGNER_MATCHING_PROFILE = gql`
  query GetDesignerMatchingProfileForProfile($designerId: String!) {
    getDesignerMatchingProfile(designerId: $designerId) {
      _id
      personalityType
      expertise {
        projectTypes
        experience
        competency {
          strengths {
            strength
            ranking
          }
        }
      }
      style {
        knownForStyle
        strongStyles
      }
      workStyle {
        minimumBudget
        partnershipOptions
      }
    }
  }
`;

export const useGetDesignerMatchingProfileQuery = () => {
  const [fetchDesignerMatchingProfile, { loading, data }] = useLazyQuery(
    GET_DESIGNER_MATCHING_PROFILE
  );

  const getDesignerMatchingProfile = useCallback(
    async (designerId: string, refresh: boolean = false) => {
      const result = await fetchDesignerMatchingProfile({
        variables: { designerId },
        fetchPolicy: refresh ? "network-only" : "cache-first",
      });
      return result?.data?.getDesignerMatchingProfile;
    },
    [fetchDesignerMatchingProfile]
  );

  return {
    getDesignerMatchingProfile,
    loading,
    matchingProfile: data?.getDesignerMatchingProfile,
  };
};
